var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-card',{attrs:{"no-body":""}},[_c('b-card-header',[_c('span',{staticClass:"text-muted"},[_c('b',[_vm._v("Laboratory Guidelines")])])]),_c('b-card-body',[_c('b-table',{attrs:{"fields":_vm.columns,"items":_vm.formatLabGuidelines(_vm.results),"bordered":""}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }